import type { TranslationKeys, TranslationKey } from './locales/en'

export type { TranslationKeys, TranslationKey }

/** Supported locale identifiers */
export type Locale = 'en' | 'zh-CN'

/** Translation dictionary shape — must match English keys exactly */
export type Translations = { readonly [K in TranslationKey]: string }

/** Interpolation parameters for dynamic strings */
export type TranslationParams = Record<string, string | number>

/** Listener callback for locale changes */
export type LocaleChangeListener = (locale: Locale) => void

/** Available locales with display metadata */
export interface LocaleInfo {
  /** Locale identifier */
  id: Locale
  /** Display name in the locale's own language */
  nativeName: string
  /** Display name in English */
  englishName: string
}

/** All supported locales with metadata */
export const SUPPORTED_LOCALES: readonly LocaleInfo[] = [
  { id: 'en', nativeName: 'English', englishName: 'English' },
  { id: 'zh-CN', nativeName: '简体中文', englishName: 'Chinese (Simplified)' },
] as const
